import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Image from 'react-bootstrap/Image';
import { get } from 'services';
import logo from 'assets/img/user-template.png';

const ProfilePicture = ({user, size, changeImage, roundedCircle = true}) => {
    const [profileImage, setProfileImage] = useState("");

    useEffect(() => {
      (async function mounted() {
        if (user.persona.foto) {
          //setProfileImage('https://sxhumanostoragetest.blob.core.windows.net/arshumanoattachmentfiles/' + user.persona.foto + process.env.REACT_APP_SAS_TOKEN)
          const data = await get('PersonaDocumento/GetFileByName/' + user.persona.foto);
          setProfileImage("data:image/jpeg;base64," + data.data);
        }
      })();
      return function cleanup() {
        setProfileImage("");
      };
    }, [changeImage])

  return (
    <>
        { 
          (profileImage && profileImage !== "") 
            ? <Image style={{height: size, width: size}} src={profileImage}  fluid roundedCircle={roundedCircle} /> 
            : <Image style={{height: size, width: size}} src={logo}  fluid roundedCircle={roundedCircle} /> 
        }
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    changeImage: state.changeImage,
  }
}

export default connect(mapStateToProps)(ProfilePicture);
